import { AgeGroup, Session } from '@generated-types';

const sessionBase: Omit<Session, 'creditProfile'> = {
    bank: {
        registrationNumber: '2351',
        name: 'Skue Sparebank',
    },
    user: {
        userId: '09817696179',
        firstName: '',
        lastName: '',
        birthDate: new Date('1976-01-09'),
        ageGroup: AgeGroup.ADULT,
    },
    channel: 'web',
    mobileBank: false,
    customerIdUrl: 'https://id.test.eika.no/web-kundeid/webresources/identifiser/',
    customerIdRedirectUrl: 'https://id.test.eika.no/web-kundeid/webresources/redirect',
    debitProfile: {
        customer: {
            bankRegistrationNumber: '2351',
            number: '09817696179',
            firstName: 'Økologisk',
            lastName: 'Drage',
            birthDate: new Date('1976-01-09'),
            address: {
                address: ['Parkveien 53'],
                postalCode: '0001',
                city: 'OSLO',
                country: 'NORGE',
            },
            contact: {
                mobile: '40239345',
                email: 'ekbtestmail@eika.no',
            },
            customerAllowedOperations: {
                getCustomerContactInfo: true,
                setCustomerContactInfo: false,
            },
        },
        allowedOperations: {
            cardAutomaticOrder: true,
            cardAutomaticReorder: true,
            digitalWallet: true,
            click2Pay: true,
        },
    },
    fraudRisk: 1,
    toggles: {
        KREDITTBANK_KREDITTKORT_BETJENING_WEB: true,
        NEW_FEATURE: true,
        AUTOMATIC_DEBIT_CARD_REORDER: true,
        SAMSUNG_PAY_PUSH_PROVISIONING: false,
    },
    highAssurance: true,
};

export const sessionMock: Session = {
    ...sessionBase,
    creditProfile: {
        customer: {
            bankRegistrationNumber: '2351',
            number: '09817696179',
            firstName: 'Økologisk',
            lastName: 'Drage',
            birthDate: new Date('1976-01-09'),
            address: {
                address: ['Parkveien 53'],
                postalCode: '0001',
                city: 'OSLO',
                country: 'NORGE',
            },
            contact: {
                mobile: '40239345',
                email: 'ekbtestmail@eika.no',
            },
            customerAllowedOperations: {
                getCustomerContactInfo: true,
                setCustomerContactInfo: false,
            },
        },
        allowedOperations: {
            digitalWallet: true,
        },
    },
};

export const mockKbSession: Session = {
    ...sessionBase,
    creditProfile: {
        customer: {
            bankRegistrationNumber: '2351',
            number: '09817696179',
            firstName: 'Økologisk',
            lastName: 'Drage',
            birthDate: new Date('1976-01-09'),
            address: {
                address: ['Parkveien 53'],
                postalCode: '0001',
                city: 'OSLO',
                country: 'NORGE',
            },
            contact: {
                mobile: '40239345',
                email: 'ekbtestmail@eika.no',
            },
            customerAllowedOperations: {
                getCustomerContactInfo: true,
                setCustomerContactInfo: false,
            },
        },
        allowedOperations: {
            digitalWallet: true,
        },
    },
    toggles: {
        KREDITTBANK_KREDITTKORT_BETJENING_WEB: true,
        NEW_FEATURE: true,
        AUTOMATIC_DEBIT_CARD_REORDER: true,
        SAMSUNG_PAY_PUSH_PROVISIONING: false,
    },
};
